import React, { createContext, useContext, useCallback, useState } from 'react';

interface LayoutContextType {
  toggleMobileDrawer: () => void;
  /** When true, the Layout's default floating hamburger button is hidden (page renders its own). */
  hideDefaultHamburger: boolean;
  setHideDefaultHamburger: (hide: boolean) => void;
}

const LayoutContext = createContext<LayoutContextType>({
  toggleMobileDrawer: () => {},
  hideDefaultHamburger: false,
  setHideDefaultHamburger: () => {},
});

export const useLayoutContext = () => useContext(LayoutContext);

interface LayoutProviderProps {
  children: React.ReactNode;
  onToggleMobileDrawer: () => void;
}

export const LayoutProvider: React.FC<LayoutProviderProps> = ({ children, onToggleMobileDrawer }) => {
  const [hideDefaultHamburger, setHideDefaultHamburger] = useState(false);

  const toggleMobileDrawer = useCallback(() => {
    onToggleMobileDrawer();
  }, [onToggleMobileDrawer]);

  return (
    <LayoutContext.Provider value={{ toggleMobileDrawer, hideDefaultHamburger, setHideDefaultHamburger }}>
      {children}
    </LayoutContext.Provider>
  );
};

export default LayoutContext;
